import React from "react";
import { useDispatch } from "react-redux";
import { setOpenLeadModal } from "../../redux/actions/lead/leadAction";
import { voiceReviewActionLabel } from "../voiceAdd/saveDraftEdit";

export const StepButton = (props) => {
  const dispatch = useDispatch();
  return (
    <>
      <div className="bg-white card-panel ex-space-y pt-0">
        <div className="action-wrapper blk-padding-y">
          <div className="action-inner-block">
            <div className="action-btn-block">
              <button
                className="btn btn-medium btn-transparent"
                type="button"
                onClick={() => {
                  props.onCancel();
                }}
              >
                Cancel
              </button>
              <button
                value="Add Instructor"
                className="btn btn-medium"
                type="submit"
              >
                {voiceReviewActionLabel(
                  `${props.edit ? "Update" : "Add"} ${props.title}`
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
